export type ChavePagina = 'canais' | 'perguntas' | 'politica';

/**
 * Como o bloco aparece no painel: aberto (`accordion`), num botão que abre a janela
 * (`modal`) ou num link para a página do bloco, na mesma aba (`pagina`) ou em outra
 * (`nova-aba`). Só o bloco de canal tem as quatro; pergunta e política, só `accordion`.
 */
export type AberturaBloco = 'accordion' | 'modal' | 'pagina' | 'nova-aba';

/** O contato do canal. Sem forma reconhecida, `href` é nulo e o valor aparece como texto. */
export interface ContatoSecao {
  rotulo: string;
  valor: string;
  href: string | null;
  /** Abre em outra aba, com `rel="noopener"`: o site do canal. */
  externo: boolean;
}

/** Um bloco do painel, como o adm cadastrou. */
export interface BlocoSecao {
  titulo: string;
  /** O HTML do editor do adm, desenhado só por `[innerHTML]` (sanitização do Angular). */
  html: string;
  /** O texto do HTML, com as entidades decodificadas: é o que a busca procura. */
  texto: string;
  abertura: AberturaBloco;
  /** A rota da página do bloco, na página interna e na nova aba; nula nas outras. */
  rota: readonly string[] | null;
}

/** Um accordion da página: uma pergunta, uma política ou um canal. */
export interface SecaoAtendimento {
  id: string;
  titulo: string;
  icone: string;
  /** O resumo da pergunta ou da política, ou a descrição do canal. */
  descricao: string;
  contato: ContatoSecao | null;
  blocos: readonly BlocoSecao[];
}

export interface IlustracaoPagina {
  src: string;
  largura: number;
  altura: number;
}

/**
 * O que é da própria página, igual para todo órgão: os textos (os mesmos da prévia do
 * adm) e a ilustração padrão, que aparece enquanto o órgão não envia uma imagem.
 */
export interface ConteudoPagina {
  titulo: string;
  subtitulo: string;
  rotuloBusca: string;
  ilustracao: IlustracaoPagina;
}

export const CONTEUDO_PAGINAS: Readonly<Record<ChavePagina, ConteudoPagina>> = {
  canais: {
    titulo: 'Outros canais de atendimento',
    subtitulo: 'Canais de atendimento disponíveis.',
    rotuloBusca: 'Buscar canal de atendimento',
    ilustracao: { src: 'assets/images/ouvidoria/outros-canais-atendimento.png', largura: 594, altura: 562 },
  },
  perguntas: {
    titulo: 'Perguntas frequentes',
    subtitulo:
      'Respostas para as dúvidas mais comuns de usuários do Portal de Atendimento Carta de Serviços ou de algum outro canal da sua Carta de Serviços.',
    rotuloBusca: 'Buscar pergunta frequente',
    ilustracao: { src: 'assets/images/ouvidoria/perguntas-frequentes.png', largura: 594, altura: 562 },
  },
  politica: {
    titulo: 'Política de atendimento ao cidadão',
    subtitulo: 'Diretrizes que orientam o atendimento ao cidadão em todos os canais.',
    rotuloBusca: 'Buscar informação',
    ilustracao: { src: 'assets/images/ouvidoria/politica-atendimento.png', largura: 594, altura: 562 },
  },
};
